import React from "react";
import {
  highlightscreate,
  highlightsdelete,
  highlightsdetail,
  highlightslist,
  highlightsupdate,
  tourviewdetail,
} from "../../../../../services/superadmin";
import { crmtourviewdetail } from "../../../../../services/cityregionaladmin";
import { Reftourdetail } from "../../../../../services/referee";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { sendhighlights } from "../../../../../services/communication";
import { scheadtourviewdetail } from "../../../../../services/schoolhead";
import dotracking from "../../../../trackinglogs";
import trackobj from "../../../../trackingpages.json";
import { coachtourviewdetail } from "../../../../../services/coach";

export const Highlights = () => {
  const { id } = useParams();
  const [filterProduct, setFilterProduct] = useState([]);
  const [tpath, setTPath] = useState([]);

  const sorting = useMemo(() => {
    return ["asc", "desc"];
  }, []);
  const columnDefs = [
    {
      headerName: "Thumbnail",
      field: "thumbnail_images",
      width: 150,
      sortable: true,
      resizable: true,
      filter: false,
      // floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== "-") {
          return <img src={tpath + params.value} height="50px" width="50px" />;
        } else {
          if (params.data.highlights_type != 3) {
            return (
              <img
                src={require("../../../../../assets/images/video.png")}
                height="50px"
                width="50px"
              />
            );
          } else {
            return (
              <img
                src={require("../../../../../assets/images/photo.png")}
                height="50px"
                width="50px"
              />
            );
          }
        }
      },
    },
    {
      headerName: "Highlights",
      field: "highlight_links",
      sortable: true,
      resizable: true,
      filter: false,
      // floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Type",
      field: "highlights_type",
      sortable: true,
      resizable: true,
      filter: false,
      // floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value == "1") {
          return "Highlights";
        } else if (params.value == "2") {
          return "Live Streaming";
        } else if (params.value == "3") {
          return "Photos Link";
        }
      },
    },
    {
      headerName: "Action",
      field: "meet_highlights_id",
      sortable: true,
      resizable: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              href={params.data.highlight_links}
              target="_blank"
              title="View Link"
              className="btn-sm btn-secondary me-2"
              onClick={() =>
                dotracking(
                  "view icon in highlights list for highlights " +
                    params.data.highlight_links +
                    " (" +
                    params.value +
                    ") in " +
                    tname +
                    " (" +
                    id +
                    ") tournament $$ " +
                    trackobj.highheading
                )
              }
            >
              <i className="fa fa-eye fa-lg"></i>
            </a>
            {localStorage.getItem("Role") !== "1" && (
              <>
                {params.data.created_by ===
                  parseInt(localStorage.getItem("UID")) && (
                  <>
                    <a
                      onClick={() => highedit(params.value, params)}
                      title="Edit Link"
                      className="btn-sm btn-success me-2"
                    >
                      <i className="fa fa-edit fa-lg"></i>
                    </a>
                    <a
                      title="Delete Link"
                      onClick={() => highdelete(params.value, params)}
                      className="btn-sm btn-danger me-2"
                    >
                      <i className="fa fa-trash fa-lg"></i>
                    </a>
                  </>
                )}
              </>
            )}
            {localStorage.getItem("Role") === "1" && (
              <>
                <a
                  onClick={() => highedit(params.value, params)}
                  title="Edit Link"
                  className="btn-sm btn-success me-2"
                >
                  <i className="fa fa-edit fa-lg"></i>
                </a>
                <a
                  title="Delete Link"
                  onClick={() => highdelete(params.value, params)}
                  className="btn-sm btn-danger me-2"
                >
                  <i className="fa fa-trash fa-lg"></i>
                </a>
              </>
            )}
          </div>
        );
      },
    },
  ];

  function highdelete(tid, tdata) {
    Swal.fire({
      title: "Are you sure want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in highlights for highlights " +
            tdata.data.highlight_links +
            " (" +
            tid +
            ") in " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.highheading
        );

        highlightsdelete(tid).then((response) => {
          if (response.status === true) {
            listall();
            toast.success(response.message);
          }
        });
      }
    });
  }

  function highedit(tid, tdata) {
    dotracking(
      "edit icon in highlights for highlights " +
        tdata.data.highlight_links +
        " (" +
        tid +
        ") in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.highheading
    );

    highlightsdetail(tid).then((response) => {
      if (response.status === true) {
        if (response.data.data !== null) {
          setELinkId(response.data.data.meet_highlights_id);
          setELinks(response.data.data.highlight_links);
          setLType(response.data.data.highlights_type);
          // if (response.data.data.thumbnail_images !== "-") {
          //   setELinkThumb(
          //     response.data.thumbnail_path + response.data.data.thumbnail_images
          //   );
          // }
          handleEShow();
        }
      }
    });
  }
  const [eshow, setEShow] = useState(false);
  const [elink, setELinks] = useState("");
  const [elinkid, setELinkId] = useState("");
  // const [elinkthumb, setELinkThumb] = useState("");

  function handleEShow() {
    setErrorMsg("");
    setHighError(false);
    setEShow(true);
  }

  function handleEclose() {
    setEShow(false);
    setELinks("");
    setELinkId("");
    // setELinkThumb("");
    setLType("");
    setErrorMsg("");
    setHighError(false);
  }

  const [tname, setTName] = useState("");
  const [show, setShow] = useState(false);
  function handleShow() {
    setLinks([{ link: "", timage: "", timageerr: "" }]);
    setLType("");
    setErrorMsg("");
    setHighError(false);
    setShow(true);
  }

  function handleclose() {
    setShow(false);
    setLinks([{ link: "", timage: "", timageerr: "" }]);
    setLType("");
    setHighError(false);
    setErrorMsg("");
  }

  const navigate = useNavigate();
  function backlist() {
    if (localStorage.getItem("Role") !== "4") {
      dotracking(
        "back button in highlights for " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.tourlistheading
      );
    }
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/tournamentlist");
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/tournamentlist");
    } else if (localStorage.getItem("Role") === "4") {
      if (localStorage.getItem("Page") === "1") {
        dotracking(
          "back button in highlights for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.tourlistheading
        );
        navigate("/schoolhead/tournamentlist");
      } else if (localStorage.getItem("Page") === "3") {
        dotracking(
          "back button in highlights for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.comtourlistheading
        );
        navigate("/schoolhead/completedtournament");
      }
    } else if (localStorage.getItem("Role") === "5") {
      navigate("/referee/tournamentlist");
    } else if (localStorage.getItem("Role") === "7") {
      navigate("/coach/tournamentlist");
    }
  }

  useEffect(() => {
    if (localStorage.getItem("Role") === "1") {
      tourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      crmtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      scheadtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
        }
      });
    } else if (localStorage.getItem("Role") === "5") {
      Reftourdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
        }
      });
    } else if (localStorage.getItem("Role") === "7") {
      coachtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
        }
      });
    }
    listall();
  }, []);

  const [links, setLinks] = useState([{ link: "", timage: "", timageerr: "" }]);
  const [ltype, setLType] = useState("");

  const handleAddLink = () => {
    setHighError(false);
    setLinks([...links, { link: "", timage: "", timageerr: "" }]);
  };

  const handleDeleteLink = (index) => {
    // const updatedLinks = [...links];
    // updatedLinks.splice(index, 1);
    // setLinks(updatedLinks);
    const updatedLinks = links.filter((_, i) => i !== index);
    setLinks(updatedLinks);
  };

  // const handleLinkChange = (index, value) => {
  //   const updatedLinks = [...links];
  //   updatedLinks[index] = value;
  //   setLinks(updatedLinks);
  // };
  const handleLinkChange = (index, field, value) => {
    const updatedLinks = links.map((link, i) =>
      i === index ? { ...link, [field]: value } : link
    );
    setLinks(updatedLinks);
  };

  function thumbfile(event, index) {
    const updatedLinks = [...links];
    updatedLinks[index].timageerr = "";
    updatedLinks[index].timage = "";
    setLinks(updatedLinks);
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        updatedLinks[index].timage = event.target.files[0];
        setLinks(updatedLinks);
      } else {
        updatedLinks[index].timageerr =
          "Thumbnail Image should be jpg, jpeg, or png format";
        setLinks(updatedLinks);
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        updatedLinks[index].timageerr =
          "Thumbnail Image size should be less than 5MB";
        setLinks(updatedLinks);
      }
    }
  }

  const [thumberror, setThumbError] = useState("");
  const [timage, setTImage] = useState("");

  function thumbfileEdit(event) {
    setThumbError("");
    setTImage("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setTImage(event.target.files[0]);
      } else {
        setThumbError("Thumbnail Image should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setThumbError("Thumbnail Image size should be less than 5MB");
      }
    }
  }

  const [errorMsg, setErrorMsg] = useState("");
  const [higherror, setHighError] = useState(false);

  function submithigh() {
    setHighError(true);

    if (ltype !== "") {
      if (elinkid !== "") {
        if (elink !== "") {
          if (thumberror === "") {
            setHighError(false);
            const temp = new FormData();
            temp.append("tournament_meet_id", id);
            temp.append("meet_highlights_id", elinkid);
            temp.append("highlights_type", ltype);
            temp.append("admin_id", localStorage.getItem("UID"));
            temp.append("highlight_links", elink);
            temp.append("thumbnail_image", timage);

            dotracking(
              "update button in add highlights for " +
                elink +
                " in " +
                tname +
                " (" +
                id +
                ") tournament $$ " +
                trackobj.highheading
            );
            highlightsupdate(temp).then((response) => {
              if (response.status === true) {
                handleEclose();
                listall();
                toast.success(response.message);
              } else {
                setErrorMsg(response.message);
              }
            });
          }
        } else {
          setErrorMsg("Please Enter Link");
        }
      } else {
        const isValid = links.every((row) => row.link !== "");
        const isError = links.every((row) => row.timageerr === "");

        // var chklink = "";

        // if (links.length !== 0) {
        //   for (let i = 0; i < links.length; i++) {
        //     if (links[i] !== "") {
        //       chklink = "";
        //     } else {
        //       chklink = "Please Enter Links";
        //       setErrorMsg("Please Enter Links");
        //     }
        //   }
        // }

        if (isValid && isError) {
          setHighError(false);
          const temp = new FormData();
          temp.append("tournament_meet_id", id);
          temp.append("highlights_count", links.length);
          temp.append("highlights_type", ltype);
          temp.append("admin_id", localStorage.getItem("UID"));
          if (links.length !== 0) {
            for (let i = 0; i < links.length; i++) {
              if (links[i].link !== "") {
                temp.append("highlight_links_" + [i + 1], links[i].link);
                temp.append("thumbnail_image_" + [i + 1], links[i].timage);
              }
            }
          }
          dotracking(
            "add button in add highlights for " +
              tname +
              " (" +
              id +
              ") tournament $$ " +
              trackobj.highheading
          );
          highlightscreate(temp).then((response) => {
            if (response.status === true) {
              handleclose();
              listall();
              toast.success(response.message);
            } else {
              setErrorMsg(response.message);
            }
          });
        }
      }
      // } else {
      //   setErrorMsg("Please Select Highlight Type");
    }
  }

  function listall() {
    highlightslist(id).then((response) => {
      if (response.status === true) {
        if (response.data.data.length !== 0) {
          setFilterProduct(response.data.data);
        }
        setTPath(response.data.thumbnail_path);
      }
    });
  }

  function sendall() {
    dotracking(
      "send notification button in highlights for " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.highheading
    );
    if (filterProduct.length !== 0) {
      Swal.fire({
        title: "Are you sure want to send?",
        showCancelButton: true,
        confirmButtonColor: "#d71635",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          sendhighlights(id).then((response) => {
            if (response.status === true) {
              toast.success(response.message);
            }
          });
        }
      });
    } else {
      Swal.fire({
        title: "Add highlights for " + tname,
        showCancelButton: true,
        confirmButtonColor: "#d71635",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      });
    }
  }
  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Highlights Upload</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Tournament</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Highlights Upload
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card mt-0">
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="text-left">
                    <h3>{tname}</h3>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="text-right">
                    <a
                      className="btn btn-success me-2 mt-1"
                      onClick={handleShow}
                    >
                      <i className="fe fe-plus"></i> Add Highlights
                    </a>
                    {(localStorage.getItem("Role") === "1" ||
                      localStorage.getItem("Role") === "3") && (
                      <a
                        className="btn btn-secondary me-2 mt-1"
                        onClick={sendall}
                      >
                        <i className="fa fa-paper-plane"></i> Send Highlights
                        Notification
                      </a>
                    )}
                    <a className="btn btn-gray mt-1" onClick={backlist}>
                      <i className="fe fe-corner-up-left"></i> Back
                    </a>
                  </div>
                </div>
              </div>

              <Modal show={show} size="lg" onHide={handleclose}>
                <Modal.Header>
                  <h4> Add Highlights</h4>
                </Modal.Header>
                <Modal.Body>
                  <div className="text-right">
                    <a onClick={handleAddLink} className="btn btn-success">
                      Add Link
                    </a>
                  </div>

                  <Row className="row-sm mx-0">
                    <Col lg={11} md={11}>
                      <div className="form-group">
                        <label className="mb-2">
                          Type <span className="errortext"> *</span>
                        </label>
                        <select
                          className="form-control"
                          value={ltype}
                          onChange={(e) => setLType(e.target.value)}
                        >
                          <option value="">Select Type</option>
                          <option value="1">Highlights</option>
                          <option value="2">Live Streaming</option>
                          <option value="3">Photos Link</option>
                        </select>
                        {!ltype && higherror && (
                          <span className="errortext">
                            Highlight Type is Required
                          </span>
                        )}
                      </div>
                    </Col>
                  </Row>

                  {links.map((link, index) => (
                    <>
                      <Row className="row-sm mx-0" key={index}>
                        <Col lg={11} md={11}>
                          <div className="form-group">
                            <label className="mb-2">
                              Highlights <span className="errortext"> *</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Highlight Link"
                              className="form-control"
                              value={link.link}
                              onChange={(e) =>
                                handleLinkChange(index, "link", e.target.value)
                              }
                            />
                            {!link.link && higherror && (
                              <span className="errortext">
                                Highlight Link is Required
                              </span>
                            )}
                          </div>
                        </Col>
                        {/* {ltype != 3 && ( */}
                          <Col lg={11} md={11}>
                            <div className="form-group">
                              <label className="mb-2">Thumbnail Image </label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={(e) => thumbfile(e, index)}
                                accept=".jpg,.jpeg,.png"
                              />
                              {link.timageerr !== "" && (
                                <span className="errortext">
                                  {link.timageerr}
                                </span>
                              )}
                            </div>
                          </Col>
                        {/* )} */}

                        {index !== 0 && (
                          <Col lg={1} md={1}>
                            <div className="form-group mt-6">
                              <a
                                className="btn btn-danger"
                                onClick={() => handleDeleteLink(index)}
                              >
                                <i className="fa fa-trash"></i>
                              </a>
                            </div>
                          </Col>
                        )}
                      </Row>
                      <hr />
                    </>
                  ))}

                  {errorMsg !== "" && (
                    <span className="errortext">{errorMsg}</span>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={handleclose}>
                    Close
                  </a>
                  <a className="btn btn-success" onClick={submithigh}>
                    Add
                  </a>
                </Modal.Footer>
              </Modal>

              <Modal show={eshow} size="lg" onHide={handleEclose}>
                <Modal.Header>
                  <h4> Update Highlights</h4>
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={11} md={11}>
                      <div className="form-group">
                        <label className="mb-2">
                          Type <span className="errortext"> *</span>
                        </label>
                        <select
                          className="form-control"
                          value={ltype}
                          onChange={(e) => setLType(e.target.value)}
                        >
                          <option value="">Select Type</option>
                          <option value="1">Highlights</option>
                          <option value="2">Live Streaming</option>
                          <option value="3">Photos Link</option>
                        </select>
                        {higherror && !ltype && (
                          <span className="errortext">
                            Highlight Type is required
                          </span>
                        )}
                      </div>
                    </Col>

                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Highlights <span className="errortext"> *</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Highlight Link"
                          className="form-control"
                          value={elink}
                          onChange={(e) => setELinks(e.target.value)}
                        />
                      </div>
                    </Col>

                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Thumbnail Image
                          {/* <span className="errortext"> *</span> */}
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={thumbfileEdit}
                          accept=".jpg,.jpeg,.png"
                        />
                        {thumberror !== "" && (
                          <span className="errortext">{thumberror}</span>
                        )}
                      </div>
                    </Col>
                  </Row>

                  {errorMsg !== "" && (
                    <span className="errortext">{errorMsg}</span>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={handleEclose}>
                    Close
                  </a>
                  <a className="btn btn-success" onClick={submithigh}>
                    Update
                  </a>
                </Modal.Footer>
              </Modal>

              <div className="ag-theme-alpine ag-style">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={sorting}
                  suppressExcelExport={true}
                  suppressDragLeaveHidesColumns={true}
                  domLayout="autoWidth"
                  onGridReady={(params) => {
                    params.api.sizeColumnsToFit();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
